"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.membership = void 0;
const tslib_1 = require("tslib");
exports.membership = (0, tslib_1.__importStar)(require("./internal"));
